import { useState } from 'react';

import { Button } from '@cobliteam/ui/components';

import { UserPermission } from '@cobliteam/common-types/src/user';

import { Analytics } from '@cobliteam/analytics';

import withPermission from '@cobliteam/base-components/src/PermissionsGate/PermissionsGate';

import Icon from '@cobliteam/ui/icons';
import InsightsModal from './components/InsightsModal';

const InsightsButton = () => {
  const [openModal, setOpenModal] = useState<boolean>(false);

  const handleClick = () => {
    Analytics.track('Insights Button Clicked');
    setOpenModal(true);
  };

  const handleOnOpen = (open: boolean) => {
    if (!open) {
      Analytics.track('Insights Modal Closed');
    }
    setOpenModal(open);
  };

  return (
    <div className='justify-center align-middle'>
      <Button onClick={handleClick} variant='outlined' color='default' size='sm' startIcon={<Icon name='sparkles' color='primary' />}>
        Insights
      </Button>
      {openModal ? <InsightsModal open={openModal} onOpen={handleOnOpen} /> : null}
    </div>
  );
};

export default withPermission(UserPermission.VIEW_ANALYTICS_AND_REPORTS, InsightsButton);
